import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRenditionFtpProfiles extends Layout {
    sourceCatxrefh: DataSource;
    sourceDpsqlh: DataSource;
    sourceRenditionFtpProfiles: DataSource;
    textboxCatxhDesc: Textbox;
    textboxCatxhId: Textbox;
    textboxFtppCatxid: Textbox;
    textboxFtppColor: Textbox;
    textboxFtppCombine: Textbox;
    textboxFtppDbalias: Textbox;
    textboxFtppExportfname: Textbox;
    textboxFtppExportline: Textbox;
    textboxFtppExportres: Textbox;
    textboxFtppFileexport: Textbox;
    textboxFtppFormat: Textbox;
    textboxFtppId: Textbox;
    textboxFtppPacking: Textbox;
    textboxFtppPackingname: Textbox;
    textboxFtppSqlgrpid: Textbox;
    textboxFtppUnit: Textbox;
    textboxFtppUnitname: Textbox;
    textboxSqlhDesc: Textbox;
    textboxSqlhGrpid: Textbox;
}
